const dataPlanExtension = {
  dataPlanExtension: {
    heading: "Mobile Connectデータエクステンション",
    cellModemIMEI: "セルモデム IMEI 番号",
    siteName: "システム名",
    siteAddress: "システムアドレス",
    cellPlanEndDate: "セルモデムプラン終了日",
    daysToExpiry: "有効期限までの日数",
    currentPlanStatus: "現在の計画状況",
    gatewaySNo: "Gateway S.NO",
    paymentStatus: "支払状況",
    lastDateOfPurchase: "最終購入日",
    extendDataPlan: "データプランの延長",
    purchasedBy: "購入者",
    purchasedFrom: "購入先",
    siteId: "システム ID",
    orderNo: "注文番号",
    footer: 'Mobile Connectデータエクステンション',
    total: '合計',
    record: '記録',
    records: '記録',
    show: '表示',
    enphase_store: 'Enphase Store',
    orderSummary: '注文の概要。',
    confirmSelection: '下記より選択内容をご確認ください。',
    noOfCellModems: 'セルモデム数',
    years: '年',
    pricePerSite: 'サイトあたりの価格',
    cancel:'キャンセル',
    submit:'送信',
    back: '戻る',
    noTokens: '** 利用可能なセルモデムはありません **',
    redirectToStoreText: 'Enphase Storeにリダイレクトしています。お待ちください...',
    toolTipExtensionInfo: '延長の対象となるのは、有効期限が180日以内のセルモデムプランのみです。',
    allCellModems: 'すべてのセルモデム',
    dataplanTitleTooltip: 'これは、既存のAT&Tセルモデムを介して提供されるEnphaseモニタリング、ソフトウェア/ファームウェアのアップグレード、およびその他のリモートサービスの拡張機能です。この延長により、新しい物理的なデバイスを購入する代わりに、接続性を更新することで、当初購入した5年間の期間を超えて、同じ物理的なハードウェアの使用を継続できます。',
    eligibleCellModems: '対象セルモデム',
    nonAdminInfo: 'セルモデムのデータプランの延長をご希望の方は、管理者までご連絡ください。',
    select: '選択',
    typeToSearch: '検索タイプ',
    dataPlanExtensionSuccess: 'Mobile Connectデータエクステンションが完了しました。支払いがダッシュボードに反映されるまでに多少時間がかかる場合があります。',
    expired: '期限切れ',
    active: 'アクティブ',
    failed: "支払いが失敗しました",
    pending: "支払い処理",
    success: "支払いが完了しました",
  }
}

export default dataPlanExtension